import { KEY_CONFIG } from 'lib/ng2-sapmp/src/config/key-config';
import { Component, OnInit, OnDestroy, ViewEncapsulation, ViewChild } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components';
import { AuthenticationService, UtilityService, ValidationService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';

import { UserSummaryProductModel, UserSummaryModel, UserSummaryProdInfoModel, UserManageModel } from './../../models/';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { UserSummaryDataService, RequestUserSummaryModel } from './shared';
import { EDIT_PERMISSION_STRING, REMOVE_PERMISSION_STRING, AUA_PERMISSION_STRING } from './user-summary.config';
declare var ENV_VAR: any; // global variable set in env.js file, imported in index.html
import { BREADCRUMBS } from 'config';
import { UserWizardModel, UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { UserWizardDataService } from './../manage-users';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot';

declare var logoutCurrentUser: any;

declare var initAriaHidden: any;
declare var removeAriaHidden: any;

@Component({
  selector: 'app-user-summary',
  templateUrl: './user-summary.component.html',
  providers: [ValidationService, UserSummaryDataService, UserWizardDataService,
    AdobeAnalyticsService], // utilityService is provided in app component already
  styleUrls: ['./user-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class UserSummaryComponent implements OnInit, OnDestroy {
  fan: string;
  ctn: string;
  singleUserDetail: any = null;
  unAssignPopup: boolean;
  id: string;
  company_id: string;
  breadCrumbs: BreadCrumbModel[];
  removeUserPopup = false;
  ruPopup = false;
  eventEmit: any;
  removeUserContentUrl: string;
  modalClass: string;
  user_manage_info: UserManageModel;
  formInputData: UserSummaryProdInfoModel;
  confirmModalPopup: ConfirmModalPopupModel;
  showProduct: boolean;
  editUserPermission: string;
  removeUserPermission: string;
  assignunassignPermission: string;
  setError: boolean;
  ErrorMessage: string;
  requestUserSummaryModel: RequestUserSummaryModel;
  focusabbleElements: any;
  ufocusabbleElements: any;
  @ViewChild('remove', { static: true }) removeElement;
  @ViewChild('removeUser') removeUserElement;
  @ViewChild('unAssign', { static: true }) unassignElement;
  reviewComponentSuccessMessageFlag = false;
  reviewComponentSuccessMessage: string = null;
  user: UserProfileModel;
  csrPermissionRemoveButton: boolean;
  pivots: Array<MobilePivotModel>;
  removeIndex = -1;
  errorFlag = false;
  unAssignModalPopUpFlag; boolean;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private userWizardDataService: UserWizardDataService,
    private userSummaryDataService: UserSummaryDataService,
    private utilityService: UtilityService,
    private formBuilder: FormBuilder,
    private validationService: ValidationService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private http: HttpClient, private pageloaderService: PageLoaderService, private breadCrumbService: BreadCrumbService) {
    this.pivots = new Array<MobilePivotModel>();
    this.csrPermissionRemoveButton = this.utilityService.checkFieldPermission('userSummary.removeUser',
      JSON.parse(sessionStorage.getItem('permissions')).perm);

  }

  ngOnInit() {
    this.pivots.push({ label: 'Console dashboard', routerLink: '/dashboard' });
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    this.singleUserDetail = JSON.parse(sessionStorage.getItem('singleUserDetail'));
    if (this.singleUserDetail !== null) {
      this.fan = this.singleUserDetail.brokerAccountClientId;
      this.ctn = this.singleUserDetail.billingClientId;
    }
    let url = this.router.routerState.snapshot.url;
    const updatedUrl = url.substring(0, url.lastIndexOf('/'));
    document.title = this.utilityService.getPageTitleConfig()[updatedUrl];
    if (this.authenticationService.getUser() === null) {
      // this.router.navigate(['login']);
      window.location.href = '/businessconsole/login';
    }
    this.unAssignModalPopUpFlag = false;
    this.showProduct = true;
    this.pageloaderService.setPageLoaderStatus(false);
    this.id = this.route.snapshot.params['id'];
    this.user = this.authenticationService.getUser();
    this.requestUserSummaryModel = new RequestUserSummaryModel();
    this.getUserInfo();
    this.userSummaryDataService.setUserManageToSession(this.id, { 'productName': 'Workspace' });
    this.editUserPermission = EDIT_PERMISSION_STRING;
    this.removeUserPermission = REMOVE_PERMISSION_STRING;
    this.assignunassignPermission = AUA_PERMISSION_STRING;
    this.unAssignPopup = false;
    this.company_id = JSON.parse(sessionStorage.getItem('user')).user.companyId;
    this.userSummaryDataService.createPageLoadProperties(this.router.routerState.snapshot.url,
      'User Summary');
  }

  getFormDetails() {
    this.pageloaderService.setPageLoaderStatus(false);
    const url = this.utilityService.getEnvConfig().getManageUserCtnUrl + this.user.companyId + '/licenses/';
    this.requestUserSummaryModel.employeeClientIdList.push(this.id);
    this.requestUserSummaryModel.fetchCriteria = { 'class': 'API::SepPagingLoadConfig', 'limit': 20, 'offset': 0, 'sortField': 'id' };
    this.userSummaryDataService.getInfo(url, this.requestUserSummaryModel)
      .subscribe(respobj => {
        this.errorFlag = false;
        this.reviewSuccess();
        if (respobj.totalLength === 0) {
          this.showProduct = false;
          this.formInputData.userSummaryProductModelArr = [];
        } else {
          this.showProduct = true;
          this.formInputData = this.userSummaryDataService.formatData(respobj, this.formInputData.userInfo);
          this.user_manage_info = new UserManageModel();
          this.user_manage_info = this.userSummaryDataService.getUserManageFromSession(this.id);
        }
        this.pageloaderService.setPageLoaderStatus(true);
      }, error => {
        this.pageloaderService.setPageLoaderStatus(true);
        this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
        this.handleError(error);
      });
  }

  getUserInfo() {
      const url = this.utilityService.getEnvConfig().bulkAssignUnAssignUrl + this.user.companyId + '/employees/' + this.id;
      this.userSummaryDataService.getUserDetails(url)
        .subscribe(respobj => {
          this.errorFlag = false;
          this.formInputData = this.userSummaryDataService.formateUserData(respobj);
          this.getFormDetails();
          this.breadCrumbService.setCurrentBreadCrumb({
            'label': this.formInputData.userInfo.firstName + ' ' +
            this.formInputData.userInfo.lastName, 'routerLink': this.router.routerState.snapshot.url
        });
        if (this.formInputData && this.formInputData.userInfo) {
          document.title += ' - ' + (this.formInputData.userInfo.firstName) + ' ' + (this.formInputData.userInfo.lastName);
        }
      }, error => {
        this.pageloaderService.setPageLoaderStatus(true);
        this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
        this.handleError(error);
      });
  }

  triggerRmUserPopup(event, focusable) {
    this.reviewComponentSuccessMessageFlag = false;
    this.utilityService.setSuccessMessage(null);
    this.ruPopup = true;
    this.eventEmit = event.target;
    this.modalClass = 'modal-lg';
    document.body.classList.add('modal-open');
    initAriaHidden();
    setTimeout(() => { document.getElementById('modalHeader').focus(); });
  }

  editUser() {
    const new_obj = this.userSummaryDataService.getUserManageFromSession(this.id);
    new_obj.user_info = new UserSummaryModel();
    new_obj.user_info = this.formInputData.userInfo;
    new_obj.userSummaryProductModelArr = [];
    new_obj.userSummaryProductModelArr = this.formInputData.userSummaryProductModelArr;
    this.userSummaryDataService.setUserManageToSession(this.id, new_obj);
    this.utilityService.setSuccessMessage(null);
    this.router.navigate(['user/edit/' + this.id]);
  }

  removeUser(status) {
    if (status === true) {
      // redirect to remove pg
      this.userSummaryDataService.removeUser(
        this.utilityService.getEnvConfig().userRemove + this.company_id + '/employees/' + this.id)
        .subscribe(respobj => {
          this.errorFlag = false;
          if (respobj) {
            this.ruPopup = false;
            document.body.classList.remove('modal-open');
            removeAriaHidden();
            const parentUrl = this.utilityService.getParentUrl();
            this.router.navigate([parentUrl]);
            this.setError = false;
            this.ErrorMessage = '';
          }
        },
        err => {
          if (err.status === 500) {
            this.ruPopup = false;
            this.setError = true;
            this.ErrorMessage = 'We couldn\'t complete your request. Please try again later.';
          } else if (err.status === 401) {
            this.ruPopup = false;
            this.setError = true;
            this.ErrorMessage = 'Session Expired, Please login again.';
            logoutCurrentUser(true);
          } else {
            this.ruPopup = false;
            this.setError = true;
            this.ErrorMessage = 'We couldn\'t complete your request. Please try again later.';
          }
          this.utilityService.loadFocusOnTop();
        });
    } else {
      this.focusabbleElements = undefined;
      this.ruPopup = false;

      document.body.classList.remove('modal-open');
      removeAriaHidden();
      setTimeout(() => { this.removeUserElement.nativeElement.focus(); });
      }
  }

  assign_product() {
    const send_user_prod_arr = [];
    for (let prod of this.formInputData.userSummaryProductModelArr) {
      send_user_prod_arr.push(prod.serviceOfferCode);
    }
    sessionStorage.removeItem('steps-manageUsers');
    if (sessionStorage.getItem('assign-wizard') !== undefined && sessionStorage.getItem('assign-wizard') !== null) {
      const assing_wizard_obj = JSON.parse(sessionStorage.getItem('assign-wizard'));
      let temp_assing_wizard_obj = new UserWizardModel();
      if (assing_wizard_obj.createUser) {
        temp_assing_wizard_obj.createUser = true;
      }
      temp_assing_wizard_obj.source = 'user';
      temp_assing_wizard_obj.userEmail = this.formInputData.userInfo.email;
      temp_assing_wizard_obj.existingProducts = send_user_prod_arr;
      temp_assing_wizard_obj.previousUrl = this.router.routerState.snapshot.url;
      this.userWizardDataService.setUserWizard(temp_assing_wizard_obj);
    } else {
      const assing_wizard_obj = new UserWizardModel();
      assing_wizard_obj.source = 'user';
      assing_wizard_obj.userEmail = this.formInputData.userInfo.email;
      assing_wizard_obj.existingProducts = send_user_prod_arr;
      assing_wizard_obj.previousUrl = this.router.routerState.snapshot.url;
      this.userWizardDataService.setUserWizard(assing_wizard_obj);
    }
    let breadCrumbs = this.breadCrumbService.getBreadCrumbs();
    let breadCrumbAlreadyExist = breadCrumbs.find(value => (value.label === 'Add a user'));
    let rowIndex;
    if (breadCrumbAlreadyExist === undefined) {
      breadCrumbAlreadyExist = breadCrumbs.find(subData => (subData.routerLink ===
        '/user/summary/' + this.id));
    }
    if (breadCrumbAlreadyExist) {
      rowIndex = breadCrumbs.findIndex((data) =>
        (data === breadCrumbAlreadyExist));
    }

    if (rowIndex !== undefined && rowIndex !== null) {
      this.breadCrumbService.removeSessionBreadCrumbProperty(rowIndex);
    }
    this.utilityService.setSuccessMessage(null);
    this.router.navigate(['/manageUsers/action']);
  }
  handleError = (error) => { // Arrow function is necessary as the context should be Parent class
    if (error) {
      this.errorFlag = true;
      if (error.status === 401) {
        this.ruPopup = false;
        this.setError = true;
        this.ErrorMessage = 'Session Expired, Please login again.';

        logoutCurrentUser(true);
      } else {
        this.ruPopup = false;
        this.setError = true;
        this.ErrorMessage = 'We couldn\'t complete your request. Please try again later.';
      }
      this.utilityService.loadFocusOnTop();
    } else {
      throw error;
    }
  }

  btnAction(event) {
    this.focusabbleElements = undefined;
    this.ufocusabbleElements = undefined;
    if (event.target) {
      event.target.focus();
    }
  }

  loadFocustelements() {
    if (!this.focusabbleElements) {
      const focusableEls = this.removeElement.nativeElement.
        querySelectorAll('a[href], area[href],' +
        ' input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
      this.focusabbleElements = Array.prototype.slice.call(focusableEls);
      this.focusabbleElements[0].focus();
    }
  }

  handleKeydown(event) {
    if (event.keyCode === KEY_CONFIG.escapeKey) {
      this.btnAction(event);
      return;
    }
    this.utilityService.handleKeyPress(event, this.focusabbleElements);
  }

  reviewSuccess() {
    if ((sessionStorage.getItem('previousRoute') === '/manageUsers/review') && (this.utilityService.getSuccessMessage() != null)
    || this.unAssignModalPopUpFlag) {
      this.reviewComponentSuccessMessageFlag = true;
      this.reviewComponentSuccessMessage = this.utilityService.getSuccessMessage();
      this.utilityService.loadFocusOnTop();
    } else {
      this.reviewComponentSuccessMessageFlag = false;
    }
  }

  openPopUp(focusable, index) {
    this.removeIndex = index;
    this.fan = this.formInputData.userSummaryProductModelArr[index].fan;
    this.ctn = this.formInputData.userSummaryProductModelArr[index].billingCtn;
    this.singleUserDetail = {};
    this.singleUserDetail.specName = this.formInputData.userSummaryProductModelArr[index].productName;
    this.reviewComponentSuccessMessageFlag = false;
    this.utilityService.setSuccessMessage(null);
    this.unAssignPopup = true;
    this.modalClass = 'modal-lg';
    setTimeout(() => { document.getElementById('modalHeaderUnassign').focus(); });
  }

  UloadFocustelements() {
    if (this.unAssignPopup) {
      document.body.classList.add('modal-open');
      initAriaHidden();
      if (!this.ufocusabbleElements) {
        const focusableEls = this.unassignElement.nativeElement.
          querySelectorAll('a[href], area[href],' +
          ' input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
        this.ufocusabbleElements = Array.prototype.slice.call(focusableEls);
        this.ufocusabbleElements[0].focus();
      }
    }
  }

  UhandleKeydown(event) {
    if (event.keyCode === KEY_CONFIG.escapeKey) {
      this.btnAction(event);
      return;
    }
    this.utilityService.handleKeyPress(event, this.ufocusabbleElements);
  }

  updateUnAssignDetails(event) {
    if (this.removeIndex !== -1) {
      const reqObj = {};
      const items = {};
      items['action'] = 'UNASSIGN';
      items['employeeClientId'] = this.id;
      items['serviceClientId'] = this.formInputData.userSummaryProductModelArr[this.removeIndex].clientId;
      items['licenseClientId'] = this.formInputData.userSummaryProductModelArr[this.removeIndex].licenseClientId;
      reqObj['items'] = [items];
      this.pageloaderService.setPageLoaderStatus(false);
      this.userSummaryDataService.unAssignUser(this.utilityService.getEnvConfig().unAssignUrl, this.user.companyId, reqObj)
        .subscribe(response => {

          let respArray = [];
          respArray = response.items.filter(data => (!!data.statusInfo && data.statusInfo.status === 'COMPLETED'));
          if ((respArray.length === 0) && response.status !== 'COMPLETED') {
            this.pageloaderService.setPageLoaderStatus(true);
            this.setError = true;
            this.ErrorMessage = 'We couldn\'t complete your request. Please try again later.';
          } else {
            this.pageloaderService.setPageLoaderStatus(true);
            this.unAssignModalPopUpFlag = true;
            this.utilityService.setSuccessMessage('We\'ve successfully un-assigned 1 of 1 licenses.');
            this.utilityService.loadFocusOnTop();
          }

          this.getFormDetails();
          this.removeIndex = -1;
        }, error => {
           this.unAssignModalPopUpFlag = false;
          this.pageloaderService.setPageLoaderStatus(true);
          this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
          this.handleError(error);
        });
      this.unAssignPopup = false;
      document.body.classList.remove('modal-open');
      removeAriaHidden();
    }
  }

  cancel(event) {
    this.unAssignModalPopUpFlag = false;
    this.ufocusabbleElements = undefined;
    this.unAssignPopup = false;
    document.body.classList.remove('modal-open');
    removeAriaHidden();
    this.btnAction(event);
  }

  ngOnDestroy() {
    this.pageloaderService.setPageLoaderStatus(true);
  }
}
